import {Component, HostListener, Inject, Input, PLATFORM_ID} from '@angular/core';
import {
  ABOUT_ROUTE,
  COMPLAINTS_AND_DISPUTES,
  CONTACT_ROUTE,
  COOKIE_POLICY_ROUTE, GENERAL_CONDITIONS_ROUTE,
  INTELLECTUAL_PROPERTY_ROUTE,
  LANDING_ROUTE,
  LOGIN_ROUTE,
  ORGANISER_DASHBOARD,
  PERSONAL_DATA_PROTECTION,
  PRIVACY_POLICY_ROUTE,
  USER_PROFILE_VIEW_ROUTE
} from "src/app/app-routing.module";
import {Router} from "@angular/router";
import {environment} from "@environment";
import {AuthenticationService, OrganiserRequestService} from "@services";
import {isPlatformBrowser} from "@angular/common";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {LanguagePickerModalComponent} from "../language-picker-modal/language-picker-modal.component";
import {TranslocoService} from "@ngneat/transloco";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  @Input() displayLargeMobileFooter: boolean = true;

  public static backendVersion?: string | null;
  FooterComponent = FooterComponent;

  environment: any = environment;
  public static clientVersion: string = "1.0.113";

  public currentWindowWidth: number = 0;

  activeLang?: string;

  constructor(private router: Router, private authenticationService: AuthenticationService, private organiserRequestService: OrganiserRequestService,
              @Inject(PLATFORM_ID) private platformId: Object, private modalService: NgbModal, private translocoService: TranslocoService) {

    if (isPlatformBrowser(this.platformId)) {
      this.currentWindowWidth = window.innerWidth;
    }
  }

  ngOnInit(): void {
    this.activeLang = this.getLanguageName(this.translocoService.getActiveLang());
  }

  getLanguageName(activeLang: string) {
    switch (activeLang) {
      case "en":
        return this.translocoService.translate('app.common.language.en');
      case "hr":
        return this.translocoService.translate('app.common.language.hr');
      case "slo":
        return this.translocoService.translate('app.common.language.slo');
      case "sr":
        return this.translocoService.translate('app.common.language.sr');
      case "bs":
        return this.translocoService.translate('app.common.language.bs');
      case "it":
        return this.translocoService.translate('app.common.language.it');
      case "de":
        return this.translocoService.translate('app.common.language.de');
      case "fr":
        return this.translocoService.translate('app.common.language.fr');
    }
    return activeLang;
  }

  goToPrivacyPolicy() {
    this.router.navigate([PRIVACY_POLICY_ROUTE]);
  }


  goToPrivate() {
    this.router.navigate([this.authenticationService.isAuthenticated() ? USER_PROFILE_VIEW_ROUTE : LOGIN_ROUTE]);
  }

  goToAdmin() {
    if (this.authenticationService.isAdminstrator() || this.authenticationService.isOrganiser()) {
      this.router.navigate([ORGANISER_DASHBOARD]);
    } else if (this.authenticationService.isAuthenticated()) {
      this.organiserRequestService.openOrganiserRequestModal();
    } else {
      this.router.navigate([LOGIN_ROUTE]);
    }
  }


  protected readonly CONTACT_ROUTE: string = CONTACT_ROUTE;
  protected readonly GENERAL_CONDITIONS_ROUTE: string = GENERAL_CONDITIONS_ROUTE;
  protected readonly COOKIE_POLICY_ROUTE: string = COOKIE_POLICY_ROUTE;
  protected readonly INTELLECTUAL_PROPERTY_ROUTE: string = INTELLECTUAL_PROPERTY_ROUTE;
  protected readonly ABOUT_ROUTE: string = ABOUT_ROUTE;
  protected readonly COMPLAINTS_AND_DISPUTES: string = COMPLAINTS_AND_DISPUTES;
  protected readonly PERSONAL_DATA_PROTECTION: string = PERSONAL_DATA_PROTECTION;
  protected readonly LANDING_ROUTE: string = LANDING_ROUTE
  protected readonly ORGANISER_DASHBOARD: string = ORGANISER_DASHBOARD

  @HostListener('window:resize')
  onResize(): void {
    this.currentWindowWidth = window.innerWidth
  }

  getClientVersion() {
    return FooterComponent.clientVersion;
  }

  openLanguagesModal() {
    const modalRef =  this.modalService.open(LanguagePickerModalComponent, {
      centered: true,
      size: 'lg',
    });
  }

}
